import React, { useState, useEffect } from "react";
import Header from "./view/_header";
import { Card, Grid, CardContent, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/index";
import { commonService } from "../../../services";
import EFooterSection from "../../e_home-page/e_footer-section/e_footer-section";
import Content from "./view/_content";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  alertText: {
    display: "flex",
    height: "95vh",
    alignItems: "center",
    justifyContent: "center",
  },
  blueColor: {
    color: theme.palette.ePrimary.base,
  },
  contentBg: {
    background: theme?.palette?.eLight?.base + " !important",
    padding: "1.5rem 1.5rem 0rem !important",
    paddingBottom: 0,
    [theme.breakpoints.down("xs")]: {
      padding: "0px !important",
      paddingBottom: "8%"
    },
  },
  cardContentStyle: {
    height: "100%",
    margin: "0px 0px",
    background: theme.palette.eWhite.base,
  },
  cardStyle: {
    minHeight: "95vh"
  },
  "@global": {
    html: {
      height: "100%",
    },
    body: {
      height: "100%",
      backgroundColor: theme?.palette?.eLight?.base,
      backgroundImage: "none !important",
    },
  },
}));

export default function EConfirmation({ 
  ticketNo,
  applicationDate,
  connectionType,
  name,
  districtPremise,
  address1Premise,
  address2Premise,
  postOfficePremise,
  divisionPremise,
  postCodePremise,
  thanaPremise,
  mobile,
  meterType,
  Load,
  tarrifType
 }) {
  const classes = useStyles();
  const [checkCircle, setCheckCircle] = useState();
  const [downloadIcon, setDownloadIcon] = useState();
  let checkCircleCode = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_CHECK_CIRCLE_IMAGE
  );
  let downloadIconCode = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_DOWNLOAD_ICON
  );
  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const {t:content, ready: contentReady} = useTranslation("content-E_CONFIRMATION_SCREEN");

  useEffect(() => {
    checkCircleCode && commonService
      .getAssestUrl(checkCircleCode)
      .then((res) => setCheckCircle(res));
  }, [checkCircleCode]);

  useEffect(() => {
    downloadIconCode && commonService
      .getAssestUrl(downloadIconCode)
      .then((res) => setDownloadIcon(res));
  }, [downloadIconCode]);

  return (
    <Grid className={classes.contentBg}>
      <Card className={classes.cardStyle}>
        <CardContent className={classes.cardContentStyle}>
          {contentReady && ticketNo ? (
            <Grid
              container
              direction="column"
              alignItems="center"
              justify="space-between"
            >
              <Grid item xs={12}>
                <Header
                  ticketNo={ticketNo}
                  applicationDate={applicationDate}
                  content={content}
                  downloadIcon={downloadIcon}
                  name={name}
                  districtPremise={districtPremise}
                  address1Premise={address1Premise}
                  address2Premise={address2Premise}
                  postOfficePremise={postOfficePremise}
                  divisionPremise={divisionPremise}
                  postCodePremise={postCodePremise}
                  thanaPremise={thanaPremise}
                  mobile={mobile}
                  connectionType={connectionType}
                  meterType={meterType}
                  Load={Load}
                  tarrifType={tarrifType}
                />
                <Content
                  ticketNo={ticketNo}
                  content={content}
                  checkCircle={checkCircle}
                  downloadIcon={downloadIcon}
                  name={name}
                  districtPremise={districtPremise}    
                  address1Premise={address1Premise}
                  address2Premise={address2Premise}
                  postOfficePremise={postOfficePremise}
                  divisionPremise={divisionPremise}
                  postCodePremise={postCodePremise} 
                  thanaPremise={thanaPremise}  
                  mobile={mobile} 
                  connectionType={connectionType}
                  meterType={meterType}
                  Load={Load}
                  tarrifType={tarrifType}
                  applicationDate={applicationDate}
                />
              </Grid>
            </Grid>
          ) : (
            <Grid className={classes.alertText}>
              <CircularProgress className={classes.blueColor} />
            </Grid>
          )}
        </CardContent>
      </Card>
      <EFooterSection />
    </Grid>
  );
}
